import { accessor } from '../store';
import { messages } from 'src/i18n/i18n';
import {
    RouteEntityDetail,
} from '@redviking/argonaut-core-ui/src/components/EntityDetail';
import { Route } from 'vue-router';
import { RouterViewSlider } from '@redviking/argonaut-core-ui/src/components/RouterViewSlider';
import { entityDetailRoute } from '../components/EntityDetail';
import { entityPageBannerTitle } from 'src/util/formatting';
import type { RouteConfig } from 'vue-router';
import { validateConnectionSelectAcl, validateConnectionUpdateAcl } from './connections.validations';
import { createConnection, getConnection, saveConnection } from './connections.entity';
import { DEFAULT_CONNECTION_ID } from '@redviking/argonaut-util/types/connections/connection-config';
import { ArgoConnectionConfigStatusEnum } from '@redviking/argonaut-util/types/db-enums/argo/connection_config_status';

const connectionRoutes: RouteConfig[] = [
    {
        path: '/connections',
        name: 'connections',
        component: RouterViewSlider,
        redirect: { name: 'connectionList' },
        meta: {
            featureFlags: [ 'unstableConnections' ],
            transition: 'horizontal',
            navbarIcon: 'mdi-connection',
            navbarTitle: messages.connections.titles.nav,
            navigationGuard: validateConnectionSelectAcl,
        },
        children: [
            {
                path: '',
                name: 'connectionList',
                component: () => import(/* webpackChunkName: "connections" */ './Connections.list.vue'),
                meta: {
                    pageBannerTitle: messages.connections.titles.pageBannerTitle,
                    pageBannerSubtitle: messages.connections.titles.pageBannerSubtitle,
                },
            },
            entityDetailRoute<'connection'>({
                path: ':connectionId/:connectionConfigId',
                component: RouteEntityDetail,
                name: 'connectionMaintenence',
                redirect: to => ({ name: 'connectionSettings', params: to.params }),
                meta: {
                    entityType: 'connection',
                    getEntity: getConnection,
                    saveEntity: saveConnection,
                    createEntity: createConnection,
                    canEdit: () => {
                        const connection = accessor.entityAsType('connection');
                        return connection?.id !== DEFAULT_CONNECTION_ID && validateConnectionUpdateAcl() && connection?.connectionConfig?.status === ArgoConnectionConfigStatusEnum.Staged;
                    },
                    returnRoute: (route: Route) => ({ name: 'connectionList', query: route.query }),
                    pageBannerTitle: () => entityPageBannerTitle('connection', accessor.entityAsType('connection')?.name),
                },
                children: [
                    {
                        path: 'settings',
                        name: 'connectionSettings',
                        component: () => import(/* webpackChunkName: "connections" */ './ConnectionSettings.vue'),
                        meta: {
                            navigationGuard: validateConnectionUpdateAcl,
                            tab: {
                                icon: 'mdi-cog',
                                label: 'Settings',
                            },
                        },
                    },
                    {
                        path: 'json',
                        name: 'connectionJson',
                        component: () => import(/* webpackChunkName: "connections" */ './Json.tab.view.vue'),
                        meta: {
                            tab: {
                                label: 'JSON',
                                icon: 'mdi-code-braces',
                            },
                        },
                    },
                ],
            }),
        ],
    },
];

export default connectionRoutes;
